class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  async onToggle() {
    // ✅ Lazy-init animations once, off the critical path
    if (!this.animations) {
      await yieldToMain();
      this.animations = this.content.getAnimations();
    }

    const isOpen = this.mainDetailsToggle.hasAttribute('open');

    // ✅ Yield before animation work — browser paints open/close first
    await yieldToMain();

    if (isOpen) {
      this.animations.forEach(a => a.play());
    } else {
      this.animations.forEach(a => a.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

function yieldToMain() {
  return typeof scheduler !== 'undefined' && scheduler.yield
    ? scheduler.yield()
    : new Promise(r => setTimeout(r, 0));
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('header-menu', HeaderMenu);
